import React from 'react'

const SubheaderFlourish = ({subheader}) => (
  <h6 className='flourish'>
    {subheader}
  </h6>
)

export default SubheaderFlourish
